import { Component, OnInit } from '@angular/core';
import { RequestHelper } from '@shared/helper/request.helper';
import { Router } from '@angular/router';
import { NavigationConstant } from '@shared/constant/navigation.constant';
import { MessageConstant } from '@shared/constant/message.constant';
import { environment } from '@environments/environment';
import { APIConstant } from '@shared/constant/api.constant';
import { paymentVaStorage } from '@shared/storage/payment-va.storage';
import { IndomaretModule } from '../indomaret.module';
import { IndomaretModel } from '@shared/data/indomaret-model';

@Component({
  selector: 'app-payment-indomaret',
  templateUrl: '../../payment.component.html'
})
export class PaymentIndomaretComponent implements OnInit {

  vaNumber: any;
  customerName: any;
  trackingRef: any;
  description: any;
  amount: any;
  inquiryData: any;
  productCode: any;

  isLoading = false;
  moduleName: string;
  imagePath: string;

  constructor(
    private apiService: RequestHelper,
    private storage: paymentVaStorage,
    private router: Router,
    private paymentDto: IndomaretModel,
  ) { }

  ngOnInit() {
    this.imagePath = this.storage.imagePath;
    this.moduleName = this.storage.moduleName;

    this.inquiryData = this.storage.inquiryResult;
    if (this.inquiryData == null) {
      this.router.navigate([NavigationConstant.INDOMARET_INQUIRY]);
    } else {
      const responseCode = this.inquiryData.responseCode;
      if (responseCode === '0' || responseCode === '00') {
        if(this.moduleName=="Alfamart"){
          this.customerName = this.inquiryData.customerName;
          this.amount = this.inquiryData.total;
          this.vaNumber = this.inquiryData.customerID;
        } else {
          this.productCode = this.storage.data.productCode;
          this.amount = this.inquiryData.amount;
          this.vaNumber = this.storage.data.vaNumber;
          this.customerName = this.inquiryData.customer;
          this.description = this.inquiryData.description;
          this.trackingRef = this.inquiryData.trackingRef;
        }
      } else if (responseCode === '30') {
        this.openDialog(MessageConstant.NOT_FOUND);
      } else if (responseCode === '88') {
      this.openDialog(MessageConstant.ALREADY_PAID);
    } else {
        this.openDialog(MessageConstant.CANNOT_PROCESS);
      }
    }
  }

  goBack() {
    this.router.navigate([NavigationConstant.INDOMARET_INQUIRY]);
  }

  submitPayment() {
    this.isLoading = true;
    if (this.amount == null || this.amount.toString().length > 10) {
      this.isLoading = false;
      this.openDialog(MessageConstant.PAYMENT_FAILED);
    } else {

      this.paymentDto.productCode = this.productCode;
      this.paymentDto.amount = this.amount;
      this.paymentDto.vaNumber = this.vaNumber;
      this.paymentDto.trackingRef = this.trackingRef;
      this.apiService.post(environment.apiUrl + APIConstant.INDOMARET_PAYMENT, JSON.stringify(this.paymentDto)).subscribe((data) => {
        this.storage.paymentResult = data;
        // this.storage.data = this.inquiryData;
        this.router.navigate([NavigationConstant.INDOMARET_PAYMENT_RESULT]);
      }, (err) => {
        this.isLoading = false;
        this.openDialog(MessageConstant.CANNOT_PROCESS);
      }
      );
    }
  }

  openDialog(result) {
    this.apiService.openDialog(result, NavigationConstant.INDOMARET_INQUIRY);
  }
}

